import styled from 'styled-components';

// The Recovery column of the desktop orders table. It is ~95-160px wide on
// laptops, too narrow for "$52.38 RECOVERED" on one line, so the badge in it
// is the $compact one.
export const RecoveryCell = styled.div`
  box-sizing: border-box;
  width: 12%;
  min-width: 0;
  padding-right: 8px;
`;

export const OrderRecoveryStatusBadge = styled.div<{
  $color?: string;
  $compact?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  max-width: 100%;
  padding: 2px 10px 2px 5px;
  border-radius: 100px;
  background-color: ${({ $color }) => $color};
  gap: 5px;
  text-align: center;

  & > * {
    flex-shrink: 0;
  }

  .recovery-amount,
  .recovery-status {
    color: inherit;
    white-space: nowrap;
  }

  .recovery-status {
    margin-left: 0.3em;
  }

  ${({ $compact }) =>
    $compact &&
    `
    padding: 4px 8px;
    border-radius: 10px;
    text-align: left;

    .recovery-icon {
      display: none;
    }

    & > .recovery-label {
      flex-shrink: 1;
      min-width: 0;
    }

    .recovery-amount,
    .recovery-status {
      display: block;
    }

    .recovery-status {
      margin-left: 0;
      font-size: 10px;
      line-height: 12px;
      white-space: normal;
    }
  `}
`;
